<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { CrossLedgerLink } from '../composables/use-cross-ledger-links.ts'

const props = defineProps<{ link: CrossLedgerLink }>()
const emit = defineEmits<{ follow: [CrossLedgerLink] }>()

const { t } = useI18n()

const label = computed(() =>
  t(`transactions.crossLedgerLink.${props.link.direction === 'OUTGOING' ? 'to' : 'from'}`, {
    ledger: props.link.counterpartLedgerName,
  }),
)
</script>

<template>
  <button
    type="button"
    class="min-h-[var(--density-target-min)] shrink-0 whitespace-nowrap rounded-full border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-[var(--space-inline)] text-[color:var(--color-text-muted)] underline decoration-transparent underline-offset-4 transition-colors duration-[var(--motion-fast)] hover:decoration-current"
    @click="emit('follow', link)"
  >
    {{ label }}
  </button>
</template>
